// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"a5da831c","221":"2fdfa88e","808":"22c33477","899":"a0a869ba"}[chunkId] + ".chunk.css";
};